var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "right-content" },
    [
      _vm.systemCode === "ERP" ? _c("EmailMarketing") : _vm._e(),
      _vm.isAppear
        ? _c(
            "a-tooltip",
            { attrs: { title: _vm.i18nRender("layouts.MoneyAssistant") } },
            [
              _c(
                "a",
                {
                  staticClass: "right-content__action",
                  on: { click: _vm.toMoneyAssistant }
                },
                [
                  _c("icon-font", {
                    staticStyle: { color: "white" },
                    attrs: { type: "gb-icon-daohang-tubiao-zijinzhushou" }
                  })
                ],
                1
              )
            ]
          )
        : _vm._e(),
      !_vm.isDemo ? _c("news-list") : _vm._e(),
      !_vm.isDemo
        ? _c("system-change", { attrs: { systems: _vm.systems } })
        : _vm._e(),
      _vm.systemCode === "ERP" ? _c("menu-transform") : _vm._e(),
      !_vm.isDemo &&
      _vm.useNewMenu === 1 &&
      Number(_vm.currentSystem.subTab) < 6 &&
      _vm.systemCode === "ERP"
        ? _c("version-change")
        : _vm._e(),
      _c(
        "a-tooltip",
        { attrs: { title: _vm.i18nRender("layouts.onlineservice") } },
        [
          _c(
            "a",
            {
              directives: [
                {
                  name: "demo",
                  rawName: "v-demo",
                  value: "getQueryList",
                  expression: "'getQueryList'"
                }
              ],
              staticClass: "right-content__action",
              attrs: { href: "javascript:;" }
            },
            [
              _c("icon-font", { attrs: { type: "gb-icon-customer-service-2" } })
            ],
            1
          )
        ]
      ),
      _c("select-lang"),
      _c("avatar-dropdown")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }